import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-left',
    templateUrl: './question-damage-image-left.component.html',
    styleUrls: ['./question-damage-image-left.component.scss'],
    standalone: false
})
export class QuestionDamageImageLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
